import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from "@angular/core";
import { Observable } from "rxjs";
import { saveAs } from 'file-saver';
import { Page } from "../../../model/Paginacao/Page";
import { Lotacao } from "../../../model/lotacao";
import { PosCampanhaService } from "../../../service/posCampanha/pos-campanha.service";
import { MatTableDataSource } from "@angular/material/table";
import { ServidorRecad } from "../../../model/servidorRecad";
import { ThemePalette } from "@angular/material/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { ToastrService } from "ngx-toastr";
import { DadosTabelaDependentePosRecad, DependentePosRecadDto } from "./dependentePosRecad.dto";
import { ModalComponent } from "../../modal/modal.component";
import { MatDialog } from "@angular/material/dialog";




@Component({
  selector: 'app-aba2-posrecad',
  templateUrl: './aba2-posrecad.component.html',
  styleUrls: ['./aba2-posrecad.component.sass']
})
export class Aba2PosrecadComponent implements OnInit, OnDestroy, OnChanges{

  @Input() servidor: ServidorRecad;
  @Output() flExibirTab: EventEmitter<any> = new EventEmitter<any>();
  @Output() salvoOutput: EventEmitter<any> = new EventEmitter<any>();
  displayedColumns: string[] = ['descricao', 'antes', 'depois', 'acoes'];
  color: ThemePalette = 'primary';
  list: DadosTabelaDependentePosRecad[] = [];
  isDisabledJustificativa: boolean = true
  justificativa: string = '';
  dependentes: DependentePosRecadDto[];

  constructor(private posCampanhaService: PosCampanhaService, private toasterService: ToastrService, public dialog: MatDialog,) { }

  ngOnInit(): void {

  }

  visualizarComprovante(comprovante: string, recadValidacaoDependentesId: number) {
    this.getVisualizarComprovante(recadValidacaoDependentesId, comprovante).subscribe(
      response => {
        const blobUrl = URL.createObjectURL(response);

        // Especifica as dimensões da nova janela (largura x altura)
        const newWindow = window.open(blobUrl, '_blank', 'width=800,height=800');

        // Verifica se a janela foi aberta com sucesso
        if (newWindow) {
          newWindow.focus();
        } else {
          this.toasterService.warning('Erro ao abrir a nova janela.', '', {
            timeOut: 1500
          });
        }
      },
      error => {
        console.log(error)
        this.toasterService.warning('Erro ao visualizar o arquivo.', '', {
          timeOut: 1500
        });
      }
    );
  }

  ngOnDestroy() {

  }

  ngOnChanges(changes: SimpleChanges) {
    this.list = [];
    this.justificativa = "";
    this.findDependentes(this.servidor.id)
  }

  updateJustificativaField() {
    const atLeastOneCheckIsFalse = this.list.some(item => !item.check);
    if (atLeastOneCheckIsFalse) {
      this.isDisabledJustificativa = false
      return true

    } else {
      this.isDisabledJustificativa = true
      this.justificativa = ''
      return false
    }
  }

  findDependentes(recadServidorId: number) {
    this.getDependentes(recadServidorId).subscribe(
      response => {
        if(response){
          this.dependentes = this.montarDadosTabela(response);
        } else {
          this.flExibirTab.emit(false);
        }
      },
      (error) => {
        console.error(error);
      }
    );
  }

  private montarDadosTabela(dependentes: DependentePosRecadDto[]): DependentePosRecadDto[] {
    dependentes.forEach( resp => {
      resp.dadosTabela = new MatTableDataSource<DadosTabelaDependentePosRecad>([]);
      resp.dadosTabela.data = [
        { descricao: "Tipo de Parentesco", informacaoSrh: resp.parentescoSrh, anexo: "anexo-parentesco", informacaoRecad: resp.parentescoRecad, check: true },
        { descricao: "CPF", informacaoSrh: resp.numeCpfSrh != null ? resp.numeCpfSrh.toString() : '', anexo: "anexo-data-nascimento", informacaoRecad: resp.numeCpfRecad.toString(), check: true },
        { descricao: "Data de Nascimento", informacaoSrh: resp.dataNascimentoSrh, anexo: "anexo-data-nascimento", informacaoRecad: resp.dataNascimentoRecad, check: true },
        { descricao: "Nome", informacaoSrh: resp.nomeDependenteSrh, anexo: "nome", informacaoRecad: resp.nomeDependenteRecad, check: true },
        { descricao: "Possui incapacidade física ou mental?", informacaoSrh: resp.flDeficienteRecad, anexo: "", informacaoRecad: resp.flDeficienteRecad, check: true },
        { descricao: "Excluir do IR?", informacaoSrh: "Não se aplica", anexo: "", informacaoRecad: resp.flExclusaoImpostoRendaRecad, check: true },
        { descricao: "Excluir para todos os fins?", informacaoSrh: "Não se aplica", anexo: "", informacaoRecad: resp.flExclusaoImpostoRendaCadRecad, check: true }
      ];
    });

    return dependentes;
  }

  private getDependentes(recadServidorId: number): Observable<DependentePosRecadDto[]> {

    return this.posCampanhaService.getDependentes(recadServidorId);
  }

  private getVisualizarComprovante(recadServidorId: number, comprovante: string): Observable<any> {
    return this.posCampanhaService.visualizarAnexosDependetes(recadServidorId, comprovante);
  }

  openDialog(dependente: DependentePosRecadDto): void {
    this.dialog.open(ModalComponent, {
      width: '450px',
      data: {
        header: 'Justificativa',
        descricao: 'Justifique o motivo de recusa:',
        labelOne: 'Cancelar',
        labelTwo: 'Salvar',
        flTextArea: true,
        action: (justificativa: string) => {
          dependente.justificativa = justificativa;
          this.salvar(dependente)
        }
      }
    });
  }

  recusar(dependente: DependentePosRecadDto){
    this.openDialog(dependente);
  }

  salvar(dependente: DependentePosRecadDto) {
    /*
    status
    1- aceito
    2-pendente
    3- recusado
    4- sem alteracao
    * */

    let body = {
      recadValidacaoDependentesId: dependente.recadValidacaoDependentesId,
      status: dependente.justificativa ? 3 : 1,
      justificativa: dependente.justificativa,
    }
    this.posCampanhaService.postDependente(body).subscribe( resp => {
      this.toasterService.success("Dados salvos com sucesso");
      dependente.pendenciaDependente = "N";
      this.salvoOutput.emit(true);
    });
  }
}
